<template>
  <Transition name="fade">
    <div
      v-if="showing"
      class="fixed pt-24 pb-10 inset-0 w-full h-screen flex items-center justify-center bg-semi-75 z-50"
    >
      <div
        class="mx-2 w-full max-w-4xl max-h-full bg-white shadow-lg rounded-lg px-5 overflow-auto"
      >
        <div class="flex flex-col sticky top-0 bg-white pt-5 z-50">
          <div class="flex">
            <div
              class="w-4/5 text-left px-3 pb-3 text-purple-700 text-2xl font-bold"
            >
              Visualización de ficha
            </div>
            <div class="w-1/5 text-right">
              <button
                aria-label="close"
                class="text-xl text-gray-500"
                @click.prevent="close"
              >
                ×
              </button>
            </div>
          </div>  

                <div class="flex flex-wrap -mx-3 pb-3">


                  <div
                    class="w-full"
                    v-for="(question, index) in questions"
                    :key="'question' + question.id_pregunta"
                  >
                    <!-- pregunta tipo ABIERTA -->
                    <div v-if="question.tipo === 'ABIERTA'"> 
                      <div class="w-full px-3 mb-6 md:mb-0">
                        <label
                          class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                          :for="'question' + index"
                          >{{ question.id_pregunta }}.-
                          {{ question.texto }}</label
                        >
                        <p
                          v-if="question.nota_para_registrante"
                          class="text-purple-700 text-xs italic font-bold mb-2 text-left"
                        >
                          {{ question.nota_para_registrante }}
                        </p>
                        <textarea
                          class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                          :id="'question' + index"
                          type="text"
                          :name="'question' + index"
                          v-model="answers[index].respuesta"
                        />
                        <p
                          v-if="answers[index].error"
                          class="text-red-500 text-xs italic pb-3"
                        >
                          Ingrese la respuesta.
                        </p>
                      </div>
<!--                       <div class="w-full px-3 mb-3">
                        <label class="w-full flex items-center text-gray-900">
                          <input
                            class="mr-2 leading-tight"
                            type="checkbox"
                            v-model="answers[index].sensible"
                          />
                          <span class="text-sm">
                            Contiene información sensible
                          </span>
                        </label>
                      </div> -->
                    </div>
                    <!-- /pregunta tipo ABIERTA -->

                    <!-- pregunta tipo MULTISELECCION -->
                    <div v-if="question.tipo === 'MULTISELECCION'">
                      <div class="w-full px-3 mb-6 md:mb-0">
                        <label
                          class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                          :for="'question' + index"
                          >{{ question.id_pregunta }}.-
                          {{ question.texto }}</label
                        >
                        <p
                          v-if="question.nota_para_registrante"
                          class="text-purple-700 text-xs italic font-bold mb-2 text-left"
                        >
                          {{ question.nota_para_registrante }}
                        </p>
                        <template
                          v-for="(option, optIndex) in question.opciones"
                        >
                          <div
                            class="flex items-center text-gray-700 font-bold"
                            :class="
                              optIndex === question.opciones.length - 1 &&
                              !question.otro
                                ? 'mb-3'
                                : ''
                            "
                            :key="'opt' + optIndex"
                          >
                            <input
                              class="mr-2 leading-tight"
                              type="checkbox"
                              v-model="
                                answers[index].respuesta.opciones[option]
                              "
                            />
                            <span class="text-sm">
                              {{ option }}
                            </span>
                          </div>
                        </template>
                        <div
                          v-if="question.otro"
                          class="flex items-center text-gray-700 font-bold mb-3"
                        >
                          <input class="mr-2 leading-tight" type="checkbox" />
                          <span class="text-sm"> Otro </span>
                          <input
                            type="text"
                            class="appearance-none bg-gray-200 text-gray-700 border rounded py-2 px-4 ml-2 leading-tight focus:outline-none focus:bg-white"
                            v-model="answers[index].respuesta.otro"
                          />
                        </div>

                        <!-- Subpreguntas de la pregunta multiselección -->
                        <template
                        v-for="(subpregunta, subSIndex) in question.subpregunta"
                      >
                        <div
                          class="w-full px-3 mb-6 md:mb-0"
                          :key="'subS' + subSIndex"
                        >
                          <label
                            class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                            :for="'subquestion' + subSIndex"
                            >{{ subpregunta.id_pregunta }}.-
                            {{ subpregunta.texto }}</label
                          >
                          <!-- Subpregunta tipo multiselección->abierta -->
                          <template v-if="subpregunta.tipo === 'ABIERTA'">
                            <textarea
                              class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                              :id="'subquestion' + subSIndex"
                              type="text"
                              :name="'subquestion' + subSIndex"
                              v-model="
                                answers[index].respuesta.subpregunta[subSIndex]
                                  .respuesta
                              "
                            />
                            <p
                              v-if="
                                answers[index].respuesta.subpregunta[subSIndex]
                                  .error
                              "
                              class="text-red-500 text-xs italic pb-3"
                            >
                              Ingrese la respuesta.
                            </p>
<!--                             <div class="w-full px-3 mb-3">
                              <label
                                class="w-full flex items-center text-gray-900"
                              >
                                <input
                                  class="mr-2 leading-tight"
                                  type="checkbox"
                                  v-model="
                                    answers[index].respuesta.subpregunta[
                                      subSIndex
                                    ].sensible
                                  "
                                />
                                <span class="text-sm">
                                  Contiene información sensible
                                </span>
                              </label>
                            </div> -->
                          </template>
                          <!-- /Subpregunta tipo multiselección->abierta -->

                          <!-- /Subpregunta tipo multiselección->selección -->
                          <template v-if="subpregunta.tipo === 'SELECCION'">
                            <div class="relative">
                              <select
                                v-model="
                                  answers[index].respuesta.subpregunta[
                                    subSIndex
                                  ].respuesta.selected_answer
                                "
                                :name="'subquestion' + subSIndex"
                                class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-2 px-4 mb-3 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                              >
                                <option disabled selected>
                                  Seleccione una
                                </option>
                                <template
                                  v-for="(
                                    option, subOIndex
                                  ) in subpregunta.opciones"
                                >
                                  <option
                                    :key="'subO' + subOIndex"
                                    :value="option"
                                  >
                                    {{ option }}
                                  </option>
                                </template>
                                <option v-if="subpregunta.otro==true" value="Otro">
                                  Otro
                                </option>                                
                              </select>
                              
                              <div
                                class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
                              >
                                <svg
                                  class="fill-current h-4 w-4"
                                  xmlns="http://www.w3.org/2000/svg"
                                  viewBox="0 0 20 20"
                                >
                                  <path
                                    d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                                  />
                                </svg>
                              </div>
                            </div>

                            <div
                              v-if="
                                answers[index].respuesta.subpregunta[subSIndex].respuesta.selected_answer === 'Otro'
                              "
                              class="flex items-center text-gray-700 font-bold mb-3"
                            >
                              <span class="text-sm"> Otro </span>
                              <input
                                type="text"
                                class="appearance-none bg-gray-200 text-gray-700 border rounded py-2 px-4 ml-2 leading-tight focus:outline-none focus:bg-white"
                                v-model="answers[index].respuesta.subpregunta[subSIndex].respuesta.otro"
                              />
                            </div>

                            <p
                              v-if="
                                answers[index].respuesta.subpregunta[subSIndex]
                                  .error
                              "
                              class="text-red-500 text-xs italic pb-3"
                            >
                              Seleccione la respuesta.
                            </p>
                          </template>
                          <!-- /Subpregunta tipo multiselección->selección -->

                          <!-- Subpregunta tipo multiselección->campos -->
                          <template v-if="subpregunta.tipo === 'CAMPOS'">
                            <template
                              v-for="(
                                campo, subFieldIndex
                              ) in subpregunta.campos"
                            >
                              <template v-if="campo.tipo === 'texto'">
                                <div :key="'subf' + subFieldIndex">
                                  <label
                                    class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                                    :for="'subquestionField' + subFieldIndex"
                                    >{{ campo.texto }}</label
                                  >
                                  <input
                                    class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                                    :id="'subquestionField' + subFieldIndex"
                                    type="text"
                                    :name="'subquestionField' + subFieldIndex"
                                    v-model="
                                      answers[index].respuesta.subpregunta[
                                        subSIndex
                                      ].respuesta[campo.texto]
                                    "
                                  />
                                </div>
                              </template>
                            </template>
                            <p
                              v-if="
                                answers[index].respuesta.subpregunta[subSIndex]
                                  .error
                              "
                              class="text-red-500 text-xs italic pb-3"
                            >
                              Ingrese la respuesta.
                            </p>
<!--                             <div class="w-full px-3 mb-3">
                              <label
                                class="w-full flex items-center text-gray-900"
                              >
                                <input
                                  class="mr-2 leading-tight"
                                  type="checkbox"
                                  v-model="
                                    answers[index].respuesta.subpregunta[
                                      subSIndex
                                    ].sensible
                                  "
                                />
                                <span class="text-sm">
                                  Contiene información sensible
                                </span>
                              </label>
                            </div> -->
                          </template>
                          <!-- /Subpregunta tipo multiselección->campos -->
                        </div>
                      </template>
                      <!-- /Subpreguntas de la pregunta multiselección -->
                      </div>
                    </div>
                    <!-- /pregunta tipo MULTISELECCION -->

                    <!-- pregunta tipo SELECCION_CONDICIONAL -->
                    <div v-if="question.tipo === 'SELECCION_CONDICIONAL'">
                      <div class="w-full px-3 mb-6 md:mb-0">
                        <label
                          class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                          :for="'question' + index"
                          >{{ question.id_pregunta }}.-
                          {{ question.texto }}</label
                        >
                        <div class="relative">
                          <select
                            v-model="answers[index].respuesta.selected_answer"
                            :name="'question' + index"
                            class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-2 px-4 mb-3 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                          >
                            <option disabled selected>Seleccione una</option>
                            <template
                              v-for="(option, scOIndex) in question.opciones"
                            >
                              <option :key="'scO' + scOIndex" :value="option">
                                {{ option }}
                              </option>
                            </template>
                          </select>
                          <div
                            class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
                          >
                            <svg
                              class="fill-current h-4 w-4"
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 20 20"
                            >
                              <path
                                d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                              />
                            </svg>
                          </div>
                        </div>
                        <p
                          v-if="answers[index].error"
                          class="text-red-500 text-xs italic pb-3"
                        >
                          Seleccione la respuesta.
                        </p>
                      </div>

                      <!-- preguntas condicionadas -->
                      <template
                        v-for="(
                          value, key, keyIndex
                        ) in question.pregunta_condicion"
                      >
                        <template
                          v-if="
                            answers[index].respuesta.selected_answer === key
                          "
                        >

                          <!-- pregunta condicionada tipo abierta -->
                          <div v-if="question.pregunta_condicion[key].tipo === 'ABIERTA'"
                            class="w-full px-3 mb-6 md:mb-0"
                            :key="'condQ' + keyIndex"
                          >
                            <label
                              class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                              :for="'questionCond' + index"
                              >{{ question.pregunta_condicion[key].id }}.-
                              {{
                                question.pregunta_condicion[key].texto
                              }}</label
                            >
                            <textarea
                              class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                              :id="'questionCond' + index"
                              type="text"
                              :name="'questionCond' + index"
                              v-model="
                                answers[index].respuesta.conditional_answer[key]
                                  .respuesta
                              "
                            />
                            <p
                              v-if="
                                answers[index].respuesta.conditional_answer[key]
                                  .error
                              "
                              class="text-red-500 text-xs italic pb-3"
                            >
                              Ingrese la respuesta.
                            </p>
<!--                             <div class="w-full px-3 mb-3">
                              <label
                                class="w-full flex items-center text-gray-900"
                              >
                                <input
                                  class="mr-2 leading-tight"
                                  type="checkbox"
                                  v-model="
                                    answers[index].respuesta.conditional_answer[
                                      key
                                    ].sensible
                                  "
                                />
                                <span class="text-sm">
                                  Contiene información sensible
                                </span>
                              </label>
                            </div> -->
                          </div>
                          <!-- /pregunta condicionada tipo abierta -->

                          <!-- pregunta condicionada multiselección -->
                          <div v-if="question.pregunta_condicion[key].tipo ==='MULTISELECCION'"
                            class="w-full px-3 mb-6 md:mb-0"
                            :key="'condQ' + keyIndex"
                          >
                            <label
                              class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                              :for="'questionCond' + index"
                              >{{ question.pregunta_condicion[key].id }}.-
                              {{
                                question.pregunta_condicion[key].texto
                              }}</label
                            >
                            <p
                              v-if="
                                question.pregunta_condicion[key]
                                  .nota_para_registrante
                              "
                              class="text-purple-700 text-xs italic font-bold mb-2 text-left"
                            >
                              {{
                                question.pregunta_condicion[key]
                                  .nota_para_registrante
                              }}
                            </p>
                            <template
                              v-for="(option, scMOIndex) in question
                                .pregunta_condicion[key].opciones"
                            >
                              <div
                                class="flex items-center text-gray-700 font-bold"
                                :class="
                                  scMOIndex ===
                                    question.pregunta_condicion[key].opciones
                                      .length -
                                      1 &&
                                  !question.pregunta_condicion[key].otro
                                    ? 'mb-3'
                                    : ''
                                "
                                :key="'scM' + scMOIndex"
                              >
                                <input
                                  class="mr-2 leading-tight"
                                  type="checkbox"
                                  v-model="
                                    answers[index].respuesta.conditional_answer[
                                      key
                                    ].respuesta.opciones[option]
                                  "
                                />
                                <span class="text-sm">
                                  {{ option }}
                                </span>
                              </div>
                            </template>
                            <div
                              v-if="question.pregunta_condicion[key].otro"
                              class="flex items-center text-gray-700 font-bold mb-3"
                            >
                              <input
                                class="mr-2 leading-tight"
                                type="checkbox"
                              />
                              <span class="text-sm"> Otro </span>
                              <input
                                type="text"
                                class="appearance-none bg-gray-200 text-gray-700 border rounded py-2 px-4 ml-2 leading-tight focus:outline-none focus:bg-white"
                                v-model="
                                  answers[index].respuesta.conditional_answer[
                                    key
                                  ].respuesta.otro
                                "
                              />
                            </div>
                          </div>
                          <!-- /pregunta condicionada multiselección -->

                          <!-- pregunta condicionada tipo selección -->
                          <div v-if="question.pregunta_condicion[key].tipo ==='SELECCION' "
                            :key="'condQ' + keyIndex"
                            class="w-full px-3 mb-6 md:mb-0"
                          >
                            <label
                              class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                              :for="'questionCond' + index"
                              >{{ question.pregunta_condicion[key].id }}.-
                              {{
                                question.pregunta_condicion[key].texto
                              }}</label
                            >
                            <p
                              v-if="
                                question.pregunta_condicion[key]
                                  .nota_para_registrante
                              "
                              class="text-purple-700 text-xs italic font-bold mb-2 text-left"
                            >
                              {{
                                question.pregunta_condicion[key]
                                  .nota_para_registrante
                              }}
                            </p>
                            <div class="relative">
                              <select
                                v-model="
                                  answers[index].respuesta.conditional_answer[
                                    key
                                  ].respuesta
                                "
                                :name="'questionCond' + index"
                                class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-2 px-4 mb-3 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                              >
                                <option disabled selected>
                                  Seleccione una
                                </option>
                                <template
                                  v-for="(option, condOIndex) in question
                                    .pregunta_condicion[key].opciones"
                                >
                                  <option
                                    :key="'condO' + condOIndex"
                                    :value="option"
                                  >
                                    {{ option }}
                                  </option>
                                </template>
                              </select>
                              <div
                                class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
                              >
                                <svg
                                  class="fill-current h-4 w-4"
                                  xmlns="http://www.w3.org/2000/svg"
                                  viewBox="0 0 20 20"
                                >
                                  <path
                                    d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                                  />
                                </svg>
                              </div>
                            </div>
                          </div>
                          <!-- /pregunta condicionada tipo selección -->

                          <!-- pregunta condicionada tipo campos -->
                          <div v-if="question.pregunta_condicion[key].tipo === 'CAMPOS'"
                            :key="'condQ' + keyIndex"
                            class="w-full px-3 mb-6 md:mb-0"
                          >
                            <template
                              v-for="(campo, condFieldIndex) in question
                                .pregunta_condicion[key].campos"
                            >
                              <template v-if="campo.tipo === 'texto'">
                                <div :key="'condf' + condFieldIndex">
                                  <label
                                    class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                                    :for="'condField' + condFieldIndex"
                                    >{{ campo.texto }}</label
                                  >
                                  <input
                                    class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                                    :id="'condField' + condFieldIndex"
                                    type="text"
                                    :name="'condField' + condFieldIndex"
                                    v-model="
                                      answers[index].respuesta
                                        .conditional_answer[key].respuesta[
                                        campo.texto
                                      ]
                                    "
                                  />
                                </div>
                              </template>
                            </template>
<!--                             <div class="w-full px-3 mb-3">
                              <label
                                class="w-full flex items-center text-gray-900"
                              >
                                <input
                                  class="mr-2 leading-tight"
                                  type="checkbox"
                                  v-model="
                                    answers[index].respuesta.conditional_answer[
                                      key
                                    ].sensible
                                  "
                                />
                                <span class="text-sm">
                                  Contiene información sensible
                                </span>
                              </label>
                            </div> -->
                          </div>
                          <!-- /pregunta condicionada tipo campos -->

                        </template>
                        <template
                          v-if="
                            answers[index].respuesta.selected_answer === key
                          "
                        >
                          <template
                            v-for="(subpregunta, subQIndex) in question
                              .pregunta_condicion[key].subpregunta"
                          >
                            <div
                              v-if="subpregunta.tipo === 'SELECCION'"
                              :key="'subCondQ' + subQIndex"
                              class="w-full px-3 mb-6 md:mb-0"
                            >
                              <label
                                class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                                :for="'subCondQ' + subQIndex"
                                >{{ subpregunta.id_pregunta }}.-
                                {{ subpregunta.texto }}</label
                              >
                              <p
                                v-if="subpregunta.nota_para_registrante"
                                class="text-purple-700 text-xs italic font-bold mb-2 text-left"
                              >
                                {{ subpregunta.nota_para_registrante }}
                              </p>
                              <div class="relative">
                                <select
                                  v-model="
                                    answers[index].respuesta.conditional_answer[
                                      key
                                    ].subpregunta[subQIndex].respuesta
                                  "
                                  :name="'subCondQ' + subQIndex"
                                  class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-2 px-4 mb-3 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                                >
                                  <option disabled selected>
                                    Seleccione una
                                  </option>
                                  <template
                                    v-for="(
                                      option, subCondOptIndex
                                    ) in subpregunta.opciones"
                                  >
                                    <option
                                      :key="'subCondOpt' + subCondOptIndex"
                                      :value="option"
                                    >
                                      {{ option }}
                                    </option>
                                  </template>
                                </select>
                                <div
                                  class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
                                >
                                  <svg
                                    class="fill-current h-4 w-4"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 20 20"
                                  >
                                    <path
                                      d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                                    />
                                  </svg>
                                </div>
                              </div>
                            </div>
                          </template>
                        </template>
                      </template>
                      <!-- /preguntas condicionadas -->
                    </div>
                    <!-- /pregunta tipo SELECCION_CONDICIONAL -->

                    <!-- pregunta tipo SELECCION -->
                    <div v-if="question.tipo === 'SELECCION'">
                      <div class="w-full px-3 mb-6 md:mb-0">
                        <label
                          class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                          :for="'question' + index"
                          >{{ question.id_pregunta }}.-
                          {{ question.texto }}</label
                        >
                        <p
                          v-if="question.nota_para_registrante"
                          class="text-purple-700 text-xs italic font-bold mb-2 text-left"
                        >
                          {{ question.nota_para_registrante }}
                        </p>
                        <div class="relative">
                          <select
                            v-model="answers[index].respuesta.selected_answer"
                            :name="'question' + index"
                            class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-2 px-4 mb-3 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                          >
                            <option disabled selected>Seleccione una</option>
                            <template
                              v-for="(option, sOIndex) in question.opciones"
                            >
                              <option :key="'sO' + sOIndex" :value="option">
                                {{ option }}
                              </option>
                            </template>
                            <option v-if="question.otro==true" value="Otro">
                              Otro
                            </option>
                          </select>
                          <div
                            class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
                          >
                            <svg
                              class="fill-current h-4 w-4"
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 20 20"
                            >
                              <path
                                d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                              />
                            </svg>
                          </div>
                        </div>
                        <div
                          v-if="
                            answers[index].respuesta.selected_answer === 'Otro'
                          "
                          class="flex items-center text-gray-700 font-bold mb-3"
                        >
                          <span class="text-sm"> Otro </span>
                          <input
                            type="text"
                            class="appearance-none bg-gray-200 text-gray-700 border rounded py-2 px-4 ml-2 leading-tight focus:outline-none focus:bg-white"
                            v-model="answers[index].respuesta.otro"
                          />
                        </div>
                        <p
                          v-if="answers[index].error"
                          class="text-red-500 text-xs italic pb-3"
                        >
                          Seleccione la respuesta.
                        </p>
                      </div>

                      <!-- subpreguntas de la pregunta de selección -->
                        <template
                        v-for="(subpregunta, subSIndex) in question.subpregunta"
                        >
                        <div
                          class="w-full px-3 mb-6 md:mb-0"
                          :key="'subS' + subSIndex"
                        >
                          <label
                            class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                            :for="'subquestion' + subSIndex"
                            >{{ subpregunta.id_pregunta }}.-
                            {{ subpregunta.texto }}</label
                          >
                           <!-- Subpregunta tipo selección->abierta -->
                          <template v-if="subpregunta.tipo === 'ABIERTA'">
                            <textarea
                              class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                              :id="'subquestion' + subSIndex"
                              type="text"
                              :name="'subquestion' + subSIndex"
                              v-model="
                                answers[index].respuesta.subpregunta[subSIndex]
                                  .respuesta
                              "
                            />
                            <p
                              v-if="
                                answers[index].respuesta.subpregunta[subSIndex]
                                  .error
                              "
                              class="text-red-500 text-xs italic pb-3"
                            >
                              Ingrese la respuesta.
                            </p>
<!--                             <div class="w-full px-3 mb-3">
                              <label
                                class="w-full flex items-center text-gray-900"
                              >
                                <input
                                  class="mr-2 leading-tight"
                                  type="checkbox"
                                  v-model="
                                    answers[index].respuesta.subpregunta[
                                      subSIndex
                                    ].sensible
                                  "
                                />
                                <span class="text-sm">
                                  Contiene información sensible
                                </span>
                              </label>
                            </div> -->
                          </template>
                          <!-- /Subpregunta tipo selección->abierta -->

                          <!-- Subpregunta tipo selección->selección -->
                          <template v-if="subpregunta.tipo === 'SELECCION'">
                            <div class="relative">
                              <select
                                v-model="
                                  answers[index].respuesta.subpregunta[
                                    subSIndex
                                  ].respuesta.selected_answer
                                "
                                :name="'subquestion' + subSIndex"
                                class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-2 px-4 mb-3 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                              >
                                <option disabled selected>
                                  Seleccione una
                                </option>
                                <template
                                  v-for="(
                                    option, subOIndex
                                  ) in subpregunta.opciones"
                                >
                                  <option
                                    :key="'subO' + subOIndex"
                                    :value="option"
                                  >
                                    {{ option }}
                                  </option>
                                </template>
                                <option v-if="subpregunta.otro==true" value="Otro">
                                  Otro
                                </option>                                  
                              </select>

                              <div
                                class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
                              >
                                <svg
                                  class="fill-current h-4 w-4"
                                  xmlns="http://www.w3.org/2000/svg"
                                  viewBox="0 0 20 20"
                                >
                                  <path
                                    d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                                  />
                                </svg>
                              </div>
                            </div>

                            <div
                              v-if="
                                answers[index].respuesta.subpregunta[subSIndex].respuesta.selected_answer === 'Otro'
                              "
                              class="flex items-center text-gray-700 font-bold mb-3"
                            >
                              <span class="text-sm"> Otro </span>
                              <input
                                type="text"
                                class="appearance-none bg-gray-200 text-gray-700 border rounded py-2 px-4 ml-2 leading-tight focus:outline-none focus:bg-white"
                                v-model="answers[index].respuesta.subpregunta[subSIndex].respuesta.otro"
                              />
                            </div>

                            <p
                              v-if="
                                answers[index].respuesta.subpregunta[subSIndex]
                                  .error
                              "
                              class="text-red-500 text-xs italic pb-3"
                            >
                              Seleccione la respuesta.
                            </p>
                          </template>
                          <!-- /Subpregunta tipo selección->selección -->

                          <!-- Subpregunta tipo selección->campos -->
                          <template v-if="subpregunta.tipo === 'CAMPOS'">
                            <template
                              v-for="(
                                campo, subFieldIndex
                              ) in subpregunta.campos"
                            >
                              <template v-if="campo.tipo === 'texto'">
                                <div :key="'subf' + subFieldIndex">
                                  <label
                                    class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                                    :for="'subquestionField' + subFieldIndex"
                                    >{{ campo.texto }}</label
                                  >
                                  <input
                                    class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                                    :id="'subquestionField' + subFieldIndex"
                                    type="text"
                                    :name="'subquestionField' + subFieldIndex"
                                    v-model="
                                      answers[index].respuesta.subpregunta[
                                        subSIndex
                                      ].respuesta[campo.texto]
                                    "
                                  />
                                </div>
                              </template>
                            </template>
                            <p
                              v-if="
                                answers[index].respuesta.subpregunta[subSIndex]
                                  .error
                              "
                              class="text-red-500 text-xs italic pb-3"
                            >
                              Ingrese la respuesta.
                            </p>
<!--                             <div class="w-full px-3 mb-3">
                              <label
                                class="w-full flex items-center text-gray-900"
                              >
                                <input
                                  class="mr-2 leading-tight"
                                  type="checkbox"
                                  v-model="
                                    answers[index].respuesta.subpregunta[
                                      subSIndex
                                    ].sensible
                                  "
                                />
                                <span class="text-sm">
                                  Contiene información sensible
                                </span>
                              </label>
                            </div> -->
                          </template>
                          <!-- /Subpregunta tipo selección->campos -->
                        </div>
                        </template>
                        <!-- /subpreguntas de la pregunta de selección -->
                    </div>
                    <!-- /pregunta tipo SELECCION -->

                    <!-- pregunta tipo CAMPOS -->
                    <div v-if="question.tipo === 'CAMPOS'">
                      <div class="w-full px-3 mb-6 md:mb-0">
                        <label
                          class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                          :for="'question' + index"
                          >{{ question.id_pregunta }}.-
                          {{ question.texto }}</label
                        >
                        <p
                          v-if="question.nota_para_registrante"
                          class="text-purple-700 text-xs italic font-bold mb-2 text-left"
                        >
                          {{ question.nota_para_registrante }}
                        </p>

                        <template
                          v-for="(campo, fieldIndex) in question.campos"
                        >
                          <template v-if="campo.tipo === 'texto'">
                            <div :key="'f' + fieldIndex">
                              <label
                                class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                                :for="'questionField' + fieldIndex"
                                >{{ campo.texto }}</label
                              >
                              <input
                                class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                                :id="'questionField' + fieldIndex"
                                type="text"
                                :name="'questionField' + fieldIndex"
                                v-model="answers[index].respuesta[campo.texto]"
                              />
                            </div>
                          </template>
                        </template>
                        <p
                          v-if="answers[index].error"
                          class="text-red-500 text-xs italic pb-3"
                        >
                          Ingrese la respuesta.
                        </p>
      <!--                   <div class="w-full px-3 mb-3">
                          <label class="w-full flex items-center text-gray-900">
                            <input
                              class="mr-2 leading-tight"
                              type="checkbox"
                              v-model="answers[index].sensible"
                            />
                            <span class="text-sm">
                              Contiene información sensible
                            </span>
                          </label>
                        </div> -->
                      </div>
                    </div>
                    <!-- /pregunta tipo CAMPOS -->
                  </div>
                </div>

                <div class="relative">

                  <div class="w-full px-3 mb-6 md:mb-0">
                    <label
                      class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                      >Palabras clave (para ayudar a encontrar el registro en el buscador)</label
                    >
                    <input
                      type="text"
                      class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                    />
                  </div>

                <label
                  class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                  >¿Alguien te proporcionó la información que registraste?</label
                >
                <div class="w-full px-3 mb-3">
                  <label class="w-full flex items-center text-gray-900">
                    <input
                      class="mr-2 leading-tight"
                      type="radio"
                      value="Si"
                      v-model="question_register_radio"
                    />
                    <span class="text-sm">
                      Si
                    </span>
                  </label>
                  <label class="w-full flex items-center text-gray-900">
                    <input
                      class="mr-2 leading-tight"
                      type="radio"
                      value="No"
                      v-model="question_register_radio"
                    />
                    <span class="text-sm">
                      No
                    </span>
                  </label>
                </div>

                <div v-if="question_register_radio=='Si'">
                  <div class="w-full px-3 mb-6 md:mb-0">
                    <label
                      class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                      >Nombre</label
                    >
                    <input
                      type="text"
                      class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                    />
                  </div>

                  <div class="w-full px-3 mb-3">
                    <label
                      class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                      >Sexo</label
                    >
                    <select
                      class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-2 px-4 mb-3 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                    >
                      <option disabled selected> Seleccione opción </option>
                      <option> Hombre </option>
                      <option> Mujer </option>
                    </select>
                  </div>

                  <div class="w-full px-3 mb-6 md:mb-0">
                    <label
                      class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                      >Edad</label
                    >
                    <input
                      min="5"
                      step="1"
                      type="number"
                      class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                    />
                  </div>

                  <div class="w-full px-3 mb-3">
                    <label
                      class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                      >¿Es mayahablante?</label
                    >
                    <select
                      class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-2 px-4 mb-3 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                    >
                      <option disabled selected> Seleccione opción </option>
                      <option> Si </option>
                      <option> No </option>
                    </select>
                  </div>
                </div>

                <label
                  class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                  >¿Deseas que tu registro sea privado?</label
                >
                <div class="w-full px-3 mb-3">
                  <label class="w-full flex items-center text-gray-900">
                    <input
                      class="mr-2 leading-tight"
                      type="radio"
                      value="Si"
                      v-model="question_share_ubication_radio"
                    />
                    <span class="text-sm">
                      Si
                    </span>
                  </label>
                  <label class="w-full flex items-center text-gray-900">
                    <input
                      class="mr-2 leading-tight"
                      type="radio"
                      value="No"
                      v-model="question_share_ubication_radio"
                    />
                    <span class="text-sm">
                      No
                    </span>
                  </label>
                </div>

<!--                 <label
                  class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                  >¿Te encuentras en la misma ubicación del patrimonio?</label
                >
                <div class="w-full px-3 mb-3">
                  <label class="w-full flex items-center text-gray-900">
                    <input
                      class="mr-2 leading-tight"
                      type="radio"
                      value="Si"
                      v-model="question_site_ubication_radio"
                    />
                    <span class="text-sm">
                      Si
                    </span>
                  </label>
                  <label class="w-full flex items-center text-gray-900">
                    <input
                      class="mr-2 leading-tight"
                      type="radio"
                      value="No"
                      v-model="question_site_ubication_radio"
                    />
                    <span class="text-sm">
                      No
                    </span>
                  </label>
                </div> -->
              </div>


        <div class="flex w-full sticky bottom-0 justify-end py-5 bg-white">
          <button
            class="ml-2 bg-purple-500 hover:bg-purple-700 px-4 py-2 text-center rounded-lg text-gray-100 tracking-wide"
            @click="close()"
          >
            Cerrar
          </button>
        </div>
        </div>

      </div>
    </div>
  </Transition>
</template>

<script>
import EventBus from "../event-bus";

export default {
  name: "project-preview-question-builder",
  data() {
    return {
      questions: [],
      answers: [],
      question_register_radio: "No",
      question_share_ubication_radio: "No",
      question_site_ubication_radio: "No"
    };
  },
  props: {
    showing: {
      required: true,
      type: Boolean,
    },
  },
  components: {
  },
  watch: {
    showing(value) {
      if (value) {
        return document.querySelector("body").classList.add("overflow-hidden");
      }

      document.querySelector("body").classList.remove("overflow-hidden");
    },
  },
  mounted() {    
    EventBus.$on("previewQuestions", this.setData);
  },
  methods: {
   setData: function(data) {
      let list =  Object.assign({}, data);
      this.questions = list.questions
      this.clearPreviewQuestionsData();
      this.formatQuestions();
    },
    closeProjectPreview() {
      this.questions = []
    },
    close() {
      this.question_register_radio = "No";
      this.question_share_ubication_radio = "No";
      this.question_site_ubication_radio = "No";
      
      this.$emit("close");
    },
    clearPreviewQuestionsData() {
      this.questions.forEach((question) => {
        switch (question.tipo) {
          case "ABIERTA":
            delete question.error;

            question.subpregunta.forEach((subpregunta) => {
              switch (subpregunta.tipo) {
                case "ABIERTA":
                  delete subpregunta.error;
                  break;
                case "SELECCION":
                  delete subpregunta.error;
                  delete subpregunta.optionError;
                  delete subpregunta.minimumError;
                  delete subpregunta.maximumOptionError;
                  break;
                case "CAMPOS":
                  delete subpregunta.error;
                  delete subpregunta.fieldError;
                  delete subpregunta.minimumError;
                  break;
                default:
                  break;
              }
            });
            break;
          case "SELECCION":
            delete question.error;
            delete question.optionError;
            delete question.minimumError;
            delete question.maximumOptionError;
            delete question.maximumSubquestionError;
            break;
          case "CAMPOS":
            delete question.error;
            delete question.fieldError;
            delete question.minimumError;
            break;
          case "SELECCION_CONDICIONAL": {
            delete question.error;
            delete question.errorCond;
            delete question.optionError;
            delete question.minimumError;
            delete question.maximumError;
            delete question.duplicateError;
            delete question.maximumOptionError;

            let pregunta_condicion = {};

            question.preguntas_condicion.forEach((condQuestion) => {
              switch (condQuestion.tipo) {
                case "ABIERTA": {
                  delete condQuestion.error;
                  let key = condQuestion.assignment;

                  delete condQuestion.assignment;
                  delete condQuestion.assignmentError;

                  pregunta_condicion[key] = condQuestion;
                  break;
                }
                case "SELECCION": {
                  delete condQuestion.error;
                  delete condQuestion.optionError;
                  delete condQuestion.minimumError;
                  delete condQuestion.maximumOptionError;

                  let key = condQuestion.assignment;

                  delete condQuestion.assignment;
                  delete condQuestion.assignmentError;

                  pregunta_condicion[key] = condQuestion;
                  break;
                }
                case "CAMPOS": {
                  delete condQuestion.error;
                  delete condQuestion.fieldError;
                  delete condQuestion.minimumError;

                  let key = condQuestion.assignment;

                  delete condQuestion.assignment;
                  delete condQuestion.assignmentError;

                  pregunta_condicion[key] = condQuestion;
                  break;
                }
                default:
                  break;
              }
            });

            delete question.preguntas_condicion;

            question.pregunta_condicion = pregunta_condicion;
            break;
          }
          default:
            break;
        }
      });
    },
    formatQuestions() {
        this.answers = [];
        this.questions.forEach((question) => {
            let answer;

            switch (question.tipo) {
            case "ABIERTA":
                answer = "";
                break;
            case "MULTISELECCION":
                answer = {
                opciones: {},
                };

                question.opciones.forEach((option) => {
                answer.opciones[option] = false;
                });

                if (question.otro) {
                answer["otro"] = "";
                }
                if (question["subpregunta"] && question["subpregunta"].length>0) {
                if (question["subpregunta"].length > 0) {
                    answer["subpregunta"] = [];
                    question["subpregunta"].forEach((question) => {
                    let subAnswer = {
                        respuesta: null,
                    };
                    subAnswer.id_pregunta = question.id_pregunta;
                    subAnswer.texto = question.texto;
                    subAnswer.tipo = question.tipo;
                    if (question.tipo === "ABIERTA") {
                        subAnswer.sensible = false;
                        subAnswer.respuesta = "";
                    }

                    if (question.tipo === "SELECCION") {
                        subAnswer.respuesta = {
                        selected_answer: "",
                        otro: ""
                        };
                    }

                    if (question.tipo === "CAMPOS") {
                        subAnswer.sensible = false;
                        subAnswer.respuesta = {};

                        question.campos.forEach((campo) => {
                        subAnswer.respuesta[campo.texto] = "";
                        });
                    }

                    subAnswer.error = false;

                    answer["subpregunta"].push(subAnswer);
                    });
                }
                }

                break;
            case "MULTISELECCION_CATEGORIAS":
                answer = {};
                if (question["otro"] == true) {
                answer["otro"] = "";
                }
                answer["categorias"] = {};
                question.categorias.forEach((categoria) => {
                answer["categorias"][categoria.categoria_nombre] = {};
                categoria.opciones.forEach((opcion) => {
                    answer["categorias"][categoria.categoria_nombre][
                    opcion
                    ] = false;
                });
                });
                break;
            case "SELECCION_CONDICIONAL":
                answer = {};
                answer["selected_answer"] = "";
                answer["conditional_answer"] = {};

                Object.entries(question.pregunta_condicion).forEach(
                ([key, value]) => {
                    answer["conditional_answer"][key] = {};
                    answer["conditional_answer"][key]["id"] = value["id"];
                    answer["conditional_answer"][key]["tipo"] = value["tipo"];
                    answer["conditional_answer"][key]["texto"] = value["texto"];

                    if (value["tipo"] == "ABIERTA") {
                    answer["conditional_answer"][key]["sensible"] = false;
                    answer["conditional_answer"][key]["respuesta"] = "";
                    }
                    if (value["tipo"] == "MULTISELECCION") {
                    answer["conditional_answer"][key]["respuesta"] = {};

                    answer["conditional_answer"][key]["respuesta"]["opciones"] =
                        {};
                    value["opciones"].forEach((opcion) => {
                        answer["conditional_answer"][key]["respuesta"]["opciones"][
                        opcion
                        ] = false;
                    });

                    if (value["otro"] == true) {
                        answer["conditional_answer"][key]["respuesta"]["otro"] = "";
                    }
                    }
                    if (value["tipo"] == "MULTISELECCION_CATEGORIAS") {
                    answer["conditional_answer"][key]["respuesta"] = {};
                    answer["conditional_answer"][key]["respuesta"]["categorias"] =
                        {};
                    value["categorias"].forEach((categoria) => {
                        answer["conditional_answer"][key]["respuesta"][
                        "categorias"
                        ][categoria.categoria_nombre] = {};
                        categoria.opciones.forEach((opcion) => {
                        answer["conditional_answer"][key]["respuesta"][
                            "categorias"
                        ][categoria.categoria_nombre][opcion] = false;
                        });
                    });
                    if (value["otro"] == true) {
                        answer["conditional_answer"][key]["respuesta"]["otro"] = "";
                    }
                    }

                    if (value["tipo"] == "SELECCION") {
                    answer["conditional_answer"][key]["respuesta"] = "";
                    }

                    if (value["tipo"] === "CAMPOS") {
                    answer["conditional_answer"][key]["sensible"] = false;
                    answer["conditional_answer"][key]["respuesta"] = {};
                    question.pregunta_condicion[key].campos.forEach((field) => {
                        answer["conditional_answer"][key]["respuesta"][
                        field.texto
                        ] = "";
                    });
                    }

                    if (question.pregunta_condicion[key].subpregunta) {
                    let subAnswers = [];
                    question.pregunta_condicion[key].subpregunta.forEach(
                        (subpregunta) => {
                        let subAnswer = {
                            id_pregunta: subpregunta.id_pregunta,
                            texto: subpregunta.texto,
                            tipo: subpregunta.tipo,
                            respuesta: "",
                        };

                        if (subAnswer.tipo === "ABIERTA") {
                            subAnswer.sensible = false;
                        }

                        subAnswers.push(subAnswer);
                        }
                    );

                    answer["conditional_answer"][key].subpregunta = subAnswers;
                    }

                    answer["conditional_answer"][key]["error"] = false;
                }
                );
                break;
            case "SELECCION":
                answer = {};
                answer["selected_answer"] = "";
                if (question.otro) {
                answer["otro"] = "";
                }
                if (question["subpregunta"] && question["subpregunta"].length>0) {
                if (question["subpregunta"].length > 0) {
                    answer["subpregunta"] = [];
                    question["subpregunta"].forEach((question) => {
                    let subAnswer = {
                        respuesta: null,
                    };
                    subAnswer.id_pregunta = question.id_pregunta;
                    subAnswer.texto = question.texto;
                    subAnswer.tipo = question.tipo;
                    if (question.tipo === "ABIERTA") {
                        subAnswer.sensible = false;
                        subAnswer.respuesta = "";
                    }

                    if (question.tipo === "SELECCION") {
                        subAnswer.respuesta = {
                        selected_answer: "",
                        };
                    }

                    if (question.tipo === "CAMPOS") {
                        subAnswer.sensible = false;
                        subAnswer.respuesta = {};

                        question.campos.forEach((campo) => {
                        subAnswer.respuesta[campo.texto] = "";
                        });
                    }

                    subAnswer.error = false;

                    answer["subpregunta"].push(subAnswer);
                    });
                }
                }
                break;
            case "CAMPOS":
                answer = {};
                question.campos.forEach((field) => {
                answer[field.texto] = "";
                });
                break;
            default:
                break;
            }

            let answerQuestion = {
            id_pregunta: question.id_pregunta,
            texto: question.texto,
            tipo: question.tipo,
            respuesta: answer,
            obligatoria: question.obligatoria,
            error: false,
            };

            if (
            answerQuestion.tipo === "ABIERTA" ||
            answerQuestion.tipo === "CAMPOS"
            ) {
            answerQuestion.sensible = false;
            }

            this.answers.push(answerQuestion);
        });
    },
  },
};
</script>

<style scoped>
.bg-semi-75 {
  background-color: rgba(0, 0, 0, 0.75);
}
</style>
